/** Texts shared by the extranet cards. */

/** Empty state of every extranet card (fiches: « aucune donnée disponible »). */
export const EMPTY_STATE_TEXT = 'aucune donnée disponible';
